import { apiClient } from './client'

export interface UiConfigContext {
  tenantName?: string | null
  region?: string | null
}

export interface UiConfig {
  components: string[]
  /**
   * IB-27 S5 (FR-M23.1 chrome half) — additive, read-only tenant/region block for the shell
   * topbar indicator. Optional/absent on any older cached payload; each field may independently
   * be `null` — the caller (`ShellContextIndicator`) omits, never fakes, an absent value.
   */
  context?: UiConfigContext
}

/**
 * `GET /me/ui-config` (docs/access-model-and-permissions.md §D) — the current actor's visible
 * UI-component keys. IB-155/IB-53b's first consumer: gates the LoanOut/ResidencyCertification/
 * ChainOfTitle `verified` flips behind the `film.labour-verify` component key.
 *
 * <b>Honesty caveat (carried from Slice A / IB-42):</b> this is client-side UX only, not a
 * security boundary — `VisibilityCompiler` registers zero bindings and `SecurityMatrixSeeder`
 * seeds only a representative subset today. The real data boundary is RLS + tenant isolation.
 * Hiding an action here must never be read as "enforced end-to-end".
 */
export async function getUiConfig(signal?: AbortSignal): Promise<UiConfig> {
  const { data } = await apiClient.get<UiConfig>('/me/ui-config', { signal })
  return data
}
